import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getWayBillData } from '../../Waybill/reducer';
import { loadWayBillById } from '../../Waybill/actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { addGlobalPopUpWrapper, clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import {
  dateFormatter, dateTimeFormatter, getLegalEntityName, infoFormatterIntl, localeFormatter, timeFormatter,
} from '../../../utils/formatters';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { AccordionDetails } from '../../../components/base/Accordion/AccordionDetails';
import { Accordion } from '../../../components/base/Accordion/Accordion';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function WayBillDetailsPopUp(props) {
  const {
    id,
  } = props;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    loadingCurrentWayBill,
    currentWayBill = {},
  } = useSelector(getWayBillData);

  const {
    dispatcher,
    waybill_valid_from_date,
    waybill_valid_until_date,
    waybill_returned_at,
    waybill_dispatched_at,
    waybill_pre_trip_medical_exam_result,
    waybill_medical_examiner,
    waybill_pre_trip_medical_exam_at,
    waybill_post_trip_medical_exam_result,
    waybill_post_trip_medical_exam_at,
    waybill_post_medical_examiner,
    waybill_pre_trip_inspection_at,
    waybill_odometer_return,
    waybill_transportation_type,
    waybill_technical_inspection_location,
    waybill_pre_trip_inspection_result,
    waybill_odometer_dispatch,
    vehicle = {},
    dictCarrier = {},
    waybill_route_type,
    applicant,
    waybill_technical_inspection_controllers_info,
  } = currentWayBill;

  useEffect(() => {
    dispatch(loadWayBillById(id)).catch(responseLogWithNotification);
  }, [id]);

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <TimerLoader loading={loadingCurrentWayBill} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.sheets.details' })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.WAY_BILL_DETAIL })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-2">
          {infoFormatterIntl('issue_created_at', dateFormatter(waybill_valid_from_date))}
          {infoFormatterIntl('issue_valid_until', dateFormatter(waybill_valid_until_date))}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('issue_start', dateFormatter(waybill_dispatched_at))}
          {infoFormatterIntl('issue_end_way', dateTimeFormatter(waybill_returned_at))}
        </Row>
        <AccordionDetails
          content={(
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle_brand', vehicle?.vehicle_brand)}
                {infoFormatterIntl('vehicle_model', vehicle?.vehicle_model)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('vehicle_plate', vehicle?.vehicle_lpn)}
                {infoFormatterIntl('vin', vehicle?.vehicle_vin)}
              </Row>
            </>
          )}
          toggleFunction={() => dispatch((addGlobalPopUpWrapper({ window2: POPUP_LIST_NAME.TRANSPORT_DETAIL, id2: vehicle?.id })))}
          title="Транспортное средство"
        />
        <AccordionDetails
          content={(
            <Row className="row-cols-2">
              {infoFormatterIntl('in_request_inf.inf_type', getLegalEntityName(dictCarrier))}
              {infoFormatterIntl('inn', dictCarrier?.inn)}
            </Row>
          )}
          toggleFunction={() => dispatch((addGlobalPopUpWrapper({ window2: POPUP_LIST_NAME.DICT_CARRIER_DETAIL, id2: dictCarrier?.id })))}
          title="Перевозчик"
        />
        <Accordion
          title="Медицинский осмотр"
          content={(
            <>
              <Row className="row-cols-2">
                {infoFormatterIntl('pre_trip_medical_examination', waybill_pre_trip_medical_exam_result)}
                {infoFormatterIntl('pre_trip_responsible', waybill_medical_examiner)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('pre_trip_date', dateFormatter(waybill_pre_trip_medical_exam_at))}
                {infoFormatterIntl('pre_trip_time', timeFormatter(waybill_pre_trip_medical_exam_at))}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('post_trip_medical_examination', waybill_post_trip_medical_exam_result)}
                {infoFormatterIntl('post_trip_responsible', waybill_post_medical_examiner)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('post_trip_date', dateFormatter(waybill_post_trip_medical_exam_at))}
                {infoFormatterIntl('post_trip_time', timeFormatter(waybill_post_trip_medical_exam_at))}
              </Row>
            </>
            )}
        />
        <Accordion
          title="Состояние автомобиля"
          content={(
            <>
              <Row className="row-cols-1">
                {infoFormatterIntl('pre_trip_control', waybill_pre_trip_inspection_result)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('post_trip_control_date', dateFormatter(waybill_pre_trip_inspection_at))}
                {infoFormatterIntl('post_trip_control_time', timeFormatter(waybill_pre_trip_inspection_at))}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('technical_condition_control', dateFormatter(waybill_pre_trip_inspection_at))}
                {infoFormatterIntl('mechanic', waybill_technical_inspection_controllers_info)}
              </Row>
              <Row className="row-cols-2">
                {infoFormatterIntl('odometer_before_trip', waybill_odometer_dispatch)}
                {infoFormatterIntl('odometer_after_trip', waybill_odometer_return)}
              </Row>
              {/* <Row className="row-cols-2"> */}
              {/*  {infoFormatterIntl('post_trip_control', post_trip_control)} */}
              {/*  {infoFormatterIntl('responsible_person', responsible_person)} */}
              {/* </Row> */}
              {/* <Row className="row-cols-2"> */}
              {/*  {infoFormatterIntl('post_trip_control_date', dateFormatter(post_trip_control_date))} */}
              {/*  {infoFormatterIntl('post_trip_control_time', timeFormatter(post_trip_control_time))} */}
              {/* </Row> */}
            </>
            )}
        />
        {/* <Accordion */}
        {/*  title="Движение горючего" */}
        {/*  content={( */}
        {/*    <> */}
        {/*      <Row className="row-cols-2"> */}
        {/*        {infoFormatterIntl('fuel_issued', fuel_issued)} */}
        {/*        {infoFormatterIntl('fuel_remaining_at_departure', fuel_remaining_at_departure)} */}
        {/*      </Row> */}
        {/*      <Row className="row-cols-2"> */}
        {/*        {infoFormatterIntl('fuel_remaining_on_return', fuel_remaining_on_return)} */}
        {/*        {infoFormatterIntl('standard_fuel_consumption', standard_fuel_consumption)} */}
        {/*      </Row> */}
        {/*      <Row className="row-cols-2"> */}
        {/*        {infoFormatterIntl('actual_fuel_consumption', actual_fuel_consumption)} */}
        {/*        {infoFormatterIntl('fuel_saving', fuel_saving)} */}
        {/*      </Row> */}
        {/*      <Row className="row-cols-2"> */}
        {/*        {infoFormatterIntl('overconsumption', overconsumption)} */}
        {/*        {infoFormatterIntl('fuel_saving', fuel_saving)} */}
        {/*      </Row> */}
        {/*    </> */}
        {/*    )} */}
        {/* /> */}
        <Accordion
          title="Отметки"
          content={(
            <Row className="row-cols-2">
              {infoFormatterIntl('waybill_transportation_type', localeFormatter('waybill_transportation_type', waybill_transportation_type))}
              {infoFormatterIntl('waybill_route_type', localeFormatter('waybill_route_type', waybill_route_type))}
            </Row>
            )}
        />
      </div>
    </div>
  );
}
